module.exports = __webpack_public_path__ + "static/media/10.4a6f010c.jpg";